module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.errorMessage) ? _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-exclamation-sign",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.errorMessage))]) : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      'form-group': true, 'has-error': (_vm.errors && _vm.errors.data)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_data"
    }
  }, [_vm._v("Plik")]), _vm._v(" "), _c('vue-upload', {
    ref: "upload",
    staticClass: "btn btn-upload",
    attrs: {
      "id": "_data",
      "name": "data",
      "headers": _vm.headers,
      "data": _vm.item,
      "post-action": _vm.fullPostAction
    },
    on: {
      "input-file": _vm.onchangeState
    }
  }, [_vm._v(_vm._s(_vm.fileName)), _c('div', {
    staticClass: "btn btn-default"
  }, [_c('span', [_vm._v("Wybierz plik")]), _c('svg-icon', {
    attrs: {
      "name": "plus"
    }
  })], 1)]), _vm._v(" "), (_vm.errors && _vm.errors.data) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_data_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.data))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    class: {
      'form-group': true, 'has-error': (_vm.errors && _vm.errors.name)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_name"
    }
  }, [_vm._v("Opis")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.name),
      expression: "item.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "",
      "id": "_name"
    },
    domProps: {
      "value": (_vm.item.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.name) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_name_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.name))]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: {
      'form-group': true, 'has-error': (_vm.errors && _vm.errors.type)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_type"
    }
  }, [_vm._v("Typ")]), _vm._v(" "), _c('dropdown-search', {
    attrs: {
      "id": "login_company",
      "elements": _vm.fileTypes,
      "emptyValue": "Wybierz typ pliku",
      "valueField": "@id",
      "nameField": "name"
    },
    model: {
      value: (_vm.item.type),
      callback: function($$v) {
        _vm.$set(_vm.item, "type", $$v)
      },
      expression: "item.type"
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.type) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_ty[e_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.type))]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21a2eca2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/UploadFile.vue
// module id = 792
// module chunks = 0